'use strict';

var getSchemaPathRequirementMap = require('../_chunks/getSchemaPathRequirementMap-DIM0tidl.js');

const getManager = (control, schema) => (name, options) => ({
    controlProps: {
        name,
        control,
        ...options,
    },
    schemaPathRequirementMap: getSchemaPathRequirementMap.getSchemaPathRequirementMap(schema),
    value: undefined,
});

exports.getManager = getManager;
//# sourceMappingURL=getManager.js.map
